import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SubTabTableComponent } from 'src/app/component/library/sub-tab-table/sub-tab-table.component';

@Component({
  selector: 'app-custom-render',
  templateUrl: './custom-render.component.html',
  styleUrls: ['./custom-render.component.css']
})
export class CustomRenderComponent implements OnInit {
  readonly SubTabTableComponent = SubTabTableComponent
  @Input() field
  constructor() { }

  ngOnInit(): void {
  }

}
